/**
 * ProtectedRoute using Supabase authentication
 * Redirects to login if no user is authenticated
 */
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteWithSupabaseProps {
  children?: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRouteWithSupabase: React.FC<ProtectedRouteWithSupabaseProps> = ({ 
  children,
  redirectTo = '/login'
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};
